export default __webpack_public_path__ + "static/media/RadioButtonChecked.2f9ee1e1.svg";